import PropTypes from 'prop-types';
import Map, { NavigationControl } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import './MapWrapper.css';

const MapWrapper = ({
    children,
    height,
    initialViewState,
    width,
    mapboxAccessToken,
}) => {
    if (!height || !width) {
        return null;
    }

    return (
        <div>
            <Map
                initialViewState={initialViewState}
                style={{
                    width,
                    height,
                }}
                mapStyle="mapbox://styles/mapbox/streets-v9"
                mapboxAccessToken={mapboxAccessToken}
                reuseMaps
            >
                {children}
                <NavigationControl position="bottom-right" />
            </Map>
        </div>
    );
};

MapWrapper.propTypes = {
    children: PropTypes.node,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    initialViewState: PropTypes.object,
    mapboxAccessToken: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default MapWrapper;
